(function () {
    'use strict';

    angular.module('iMatApp')
        .factory('materialsManager', materialsManager);

    materialsManager.$inject = ['$q', '$log', 'materialsService', 'modelService', 'mainWorkspace'];

    function materialsManager($q, $log, materialsService, modelService, mainWorkspace) {
        var cancelerDefer = null;

        var service = {
            runProductWatching: runProductWatching
        };

        return service;

        // --------------------------------------------------------------------------------------------------------------------

        function runProductWatching($scope) {
            $scope.$watch(function () {
                return mainWorkspace.product.productTemplateId;
            }, productTemplateChanged);

            $scope.$watch(function () {
                return mainWorkspace.product.id;
            }, productChanged);
        }

        function productTemplateChanged(newProductTemplateId) {
            if (!newProductTemplateId) {
                return;
            }

            if (cancelerDefer) {
                cancelerDefer.resolve('CANCELED');
            }

            cancelerDefer = $q.defer();

            mainWorkspace.materials = [];
            setupMaterialsForProduct(mainWorkspace.product, cancelerDefer.promise)
                .then(function (materials) {
                    mainWorkspace.materials = materials;
                    $log.debug("Set materials to workspace. ", materials);
                })
                .finally(function () {
                    cancelerDefer.reject();
                    cancelerDefer = null;
                });
        }

        function productChanged() {
            if (mainWorkspace.materials) {
                setMaterialColourForProduct(mainWorkspace.materials, mainWorkspace.product);
            }
        }

        function setupMaterialsForProduct(product, canceler) {
            $log.debug("setupMaterialsForProduct for productTemplateId: " + product.productTemplateId);

            return materialsService.getMaterials(product.productTemplateId, true, canceler)
                .then(function (materials) {
                    setMaterialColourForProduct(materials, product);
                    return materials;
                })
                .catch(function (reason) {
                    throw new Upload3DModelGeneralError('Load materials failed.', reason);
                });
        }

        function setMaterialColourForProduct(materials, product) {
            if (product.isMaterialColourDraft()) {
                var materialId = product.material().id;
                var colourId = product.colour() ? product.colour().id : null;

                var materialColour = getMaterialColourById(materials, materialId, colourId);
                if (materialColour) {
                    product.setMaterialColour(materialColour.material, materialColour.colour);
                    return;
                }
            }

            product.material(materials[0]);
        }

        function getMaterialColourById(materials, materialId, colourId) {
            var material = _.find(materials, function (material) {
                return material.id === materialId;
            });

            if (angular.isUndefined(material)) {
                return null;
            }

            var colour = _.find(material.colours, function (colour) {
                return colour.id === colourId;
            });

            if (angular.isUndefined(colour)) {
                colour = material.colours[0];
            }

            return {
                material: material,
                colour: colour
            };
        }
    }
})();